import { render, staticRenderFns } from "./groupWave.vue?vue&type=template&id=1cc9434b&"
import script from "./groupWave.vue?vue&type=script&lang=js&"
export * from "./groupWave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports